import request from '@/utils/request';
import { stringify } from 'qs';

//================首页=====================

//我的收益
export async function incomes(): Promise<any> {
  return request('/api/v1/user/incomes');
}

//增减明细
export async function scores(params: any): Promise<any> {
  return request(`/api/v1/user/score?${stringify(params)}`);
}

//注册
export async function register(params: any): Promise<any> {
  return request(`/api/v1/fake/register`, {
    method: 'POST',
    data: params,
  });
}

//可提现抢分币
export async function cashScore(params: any): Promise<any> {
  return request(`/api/v1/user/score/cash`);
}

//提现
export async function cash(params: any): Promise<any> {
  return request(`/api/v1/user/score/cash`, {
    method: 'POST',
    data: params,
  });
}

//获取验证码
export async function code(params: any): Promise<any> {
  return request(`/api/v1/codes/new`, {
    method: 'POST',
    data: params,
  });
}

//获取分享图片
export async function shareData(params: any): Promise<any> {
  return request(`/api/v1/shares?${stringify(params)}`);
}

//下级用户点击量
export async function ClickNum(params: string): Promise<any> {
  return request(`/api/v1/user/${params}/click/number`);
}

//优惠课程API
export async function courseIdApi(): Promise<any> {
  return request(`/api/v1/new/user/activity/course`);
}

// 图形验证码
export async function numberCodes() {
  return request(`/api/v1/number/codes`, {
    method: 'POST',
  });
}
